// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__v+ZAh","btn":"Pagination_btn__RGopE","active":"Pagination_active__q3h4d"};